import Framework7 from 'framework7/framework7-lite.esm.bundle.js';
import CacheService from './Cache.js';
import Flash from '../FlashUtils';
import cerrarSesionPor401, { CERRADA, OTRA_SESION } from '../utils/cierreDeSesionPor401.js';
import AvisoUnicoDeError from '../utils/avisoUnicoDeError.js';
import { generacionActual, sigueLaGeneracion, atarALaSesion } from '../utils/sesionDePeticiones.js';

const DatabaseModel = {
    server: process.env.VUE_APP_SERVER,
    server_movilidad: process.env.VUE_APP_SERVER_MOVILIDAD,
    prefix: 'movilidad/',
    updateMany: 'updatemany',
    client_id: process.env.VUE_APP_CLIENT_ID,
    client_secret: process.env.VUE_APP_CLIENT_SECRET,
    cache_expiration_time: 60000,
    request: Framework7.request,
    getList: function(params, forceReload) {
        var self = this;
        params = params || {}
        var paramsDefault = {
            currentPage: (params.page || 1) - 1,
            perPage: params.limit,
            sortBy: params.order,
            sortDesc: params.orderDir == 'DESC' ? true : false,
            complete: params.complete,
            projection: params.projection,
            operation: params.operation
        };
        var params_ser = Framework7.utils.serializeObject(paramsDefault);
        var paramsRequest = {
            url: self.server_movilidad + self.prefix + self.model + '/search/?' + params_ser,
            method: 'POST',
            data: params.filter || {}
        };
        return self.sendRequest(paramsRequest, !forceReload);
    },
    sendToSAP: function(params, forceReload) {
        var self = this;
        params = params || {}
        var paramsDefault = {
            currentPage: (params.page || 1) - 1,
            perPage: params.limit,
            sortBy: params.order,
            sortDesc: params.orderDir == 'DESC' ? true : false,
            complete: params.complete,
            projection: params.projection,
            operation: params.operation
        };
        var params_ser = Framework7.utils.serializeObject(paramsDefault);
        var paramsRequest = {
            url: self.server_movilidad + self.prefix + self.model + '/sendToSap/?' + params_ser,
            method: 'POST',
            data: params.filter || {}
        };
        return self.sendRequest(paramsRequest, !forceReload);
    },
    getCombo: function(params, shownFields = []){
        var self = this;
        var comboParams = Object.assign({}, params);
        if(shownFields.length){
            comboParams.projection = shownFields.join(",");
        }
        return self.getList(comboParams);
    },
    get: function(params, forceReload) {
        var self = this;
        var forceReload = typeof forceReload == "undefined" || forceReload ? true : false;
        params = params || {};
        if (!params.itemId) reject({ error: 'itemId not defined' });
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/',
            method: 'GET',
            data: {}
        };
        return self.sendRequest(params, !forceReload);
    },
    getHistory: function(params, forceReload) {
        var self = this;
        var forceReload = typeof forceReload == "undefined" || forceReload ? true : false;
        params = params || {};
        if (!params.itemId) return;
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/history',
            method: 'GET',
            data: {}
        };
        return self.sendRequest(params, !forceReload);
    },
    hasHistory: function(forceReload) {
        var self = this;
        var forceReload = typeof forceReload == "undefined" || forceReload ? true : false;
        params = params || {};
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/hasHistory',
            method: 'GET',
            data: {}
        };
        return self.sendRequest(params, !forceReload);
    },
    saveHistory: function(params) {
        var self = this;
        var forceReload = typeof forceReload == "undefined" || forceReload ? true : false;
        params = params || {};
        if (!params.itemId) return;
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/history',
            method: 'PUT',
            data: params.data
        };
        return self.sendRequest(params, !forceReload);
    },
    deleteHistory: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemId) return;
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/history',
            method: 'DELETE',
            data: params.data
        };
        return self.sendRequest(params, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    save: function(params) {
        var self = this;
        if (params.itemId) {
            return self.put(params);
        } else {
            return self.post(params);
        }
    },
    put: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemId) reject({ error: 'itemId not defined' });
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId,
            method: 'PUT',
            data: params.data
        };
        return self.sendRequest(params, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    putAll: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemIds) reject({ error: 'itemIds not defined' });
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + self.updateMany,
            method: 'PUT',
            data: {
                ids: params.itemIds,
                dto: params.data,
                vaciarCampos: params.vaciarCampos
            }
        };
        return self.sendRequest(params, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    // Cambio masivo "progresivo": lanza el updatemany por lotes en el servidor (vía SSE). Devuelve
    // enseguida ({lanzado, total, enCurso}); el progreso llega por CambioMasivoEvents. No hay 524
    // porque la petición no espera a que termine el trabajo.
    lanzarCambioMasivoSse: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemIds) return Promise.reject({ error: 'itemIds not defined' });
        var requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/updatemany/sse',
            method: 'POST',
            data: {
                ids: params.itemIds,
                dto: params.data,
                vaciarCampos: params.vaciarCampos
            }
        };
        return self.sendRequest(requestParams, false);
    },
    cancelarCambioMasivoSse: function() {
        var self = this;
        var requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/updatemany/cancelar',
            method: 'POST',
            data: {}
        };
        return self.sendRequest(requestParams, false);
    },
    estadoCambioMasivoSse: function() {
        var self = this;
        var requestParams = {
            url: self.server_movilidad + self.prefix + self.model + '/updatemany/estado',
            method: 'GET',
            data: {}
        };
        return self.sendRequest(requestParams, false);
    },
    putAllProgress: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemIds) return Promise.reject({ error: 'itemIds not defined' });
        
        // #663 · Atada a la sesión: solo la terminan los `then`/`catch` de dentro, que no corren si
        // la sesión cambia mientras se espera, y sin atarla se quedaría pendiente para siempre.
        return atarALaSesion(new Promise((resolve, reject) => {
            // Primero iniciamos la operación
            var requestParams = {
                url: self.server_movilidad + self.prefix + self.model + '/' + self.updateMany + '/progress',
                method: 'PUT',
                data: {
                    ids: params.itemIds,
                    dto: params.data,
                    vaciarCampos: params.vaciarCampos
                }
            };
            
            self.sendRequest(requestParams, false).then(function(operationId) {
                // operationId es el UUID devuelto por el servidor
                console.log('Operación iniciada con ID:', operationId);
                
                // Conectamos al WebSocket para recibir actualizaciones
                var socket = new WebSocket(`ws://${window.location.host}/ws`);
                var stompClient = null;
                
                // Intentamos conectar con SockJS si está disponible
                if (window.SockJS) {
                    socket = new SockJS(self.server_movilidad + 'ws');
                }
                
                if (window.Stomp) {
                    stompClient = Stomp.over(socket);
                    self._escucharProgreso(stompClient, operationId, params, resolve, reject);
                } else {
                    console.warn('Stomp no disponible, usando polling como fallback');
                    // Fallback: polling si no hay WebSocket disponible
                    self._pollProgress(operationId, params.onProgress).then(resolve).catch(reject);
                }
                
            }).catch(function(error) {
                console.error('Error iniciando operación:', error);
                reject(error);
            });
        }));
    },
    // La suscripción al progreso de `putAllProgress`, aparte para no anidar sus callbacks dentro de
    // la promesa y la petición que la lanzan.
    _escucharProgreso: function(stompClient, operationId, params, resolve, reject) {
        const self = this;
        // Conectamos y nos suscribimos
        stompClient.connect({}, function(frame) {
            console.log('Conectado a WebSocket:', frame);
            
            // Nos suscribimos al canal de progreso específico
            const subscription = stompClient.subscribe(`/topic/updatemany/${operationId}`, function(message) {
                const progress = JSON.parse(message.body);
                
                console.log(`Progreso: ${progress.porcentaje.toFixed(1)}% - ${progress.procesados}/${progress.total}`);
                
                // Llamamos al callback de progreso si existe
                if (params.onProgress && typeof params.onProgress === 'function') {
                    params.onProgress(progress);
                }
                
                // Si está completado, desconectamos y resolvemos
                if (progress.completado) {
                    subscription.unsubscribe();
                    stompClient.disconnect();
                    CacheService.clearCache(self.model);
                    resolve(progress);
                }
            });
        }, function(error) {
            console.error('Error conectando a WebSocket:', error);
            reject({ error: 'Error en conexión WebSocket', details: error });
        });
    },
    // Método de fallback por si no hay WebSocket
    _pollProgress: function(operationId, onProgressCallback) {
        var self = this;
        return new Promise((resolve, reject) => {
            var checkInterval = setInterval(function() {
                // Aquí necesitarías un endpoint para consultar el estado
                // Por ahora simulamos que termina después de un tiempo
                var progress = {
                    operationId: operationId,
                    procesados: 0,
                    total: 0,
                    exitosos: 0,
                    fallidos: 0,
                    porcentaje: 0,
                    completado: false,
                    mensaje: 'Procesando...'
                };
                
                if (onProgressCallback && typeof onProgressCallback === 'function') {
                    onProgressCallback(progress);
                }
                
                // Simulación de completado después de 10 segundos
                setTimeout(function() {
                    clearInterval(checkInterval);
                    progress.completado = true;
                    progress.porcentaje = 100;
                    CacheService.clearCache(self.model);
                    resolve(progress);
                }, 10000);
            }, 1000);
        });
    },
    post: function(params) {
        var self = this;
        params = params || {};
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/',
            method: 'POST',
            data: params.data
        };
        return self.sendRequest(params, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    delete: function(params) {
        var self = this;
        params = params || {};
        if (!params.itemId) reject({ error: 'itemId not defined' });
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId,
            method: 'DELETE',
            data: params.data
        };
        return self.sendRequest(params, false).then(function(res) {
            CacheService.clearCache(self.model);
            return res;
        });
    },
    define: function(params, forceReload){
        var self = this;
        var forceReload = typeof forceReload == "undefined" || forceReload ? true : false;
        params = params || {};
        var params = {
            url: self.server_movilidad + self.prefix + self.model + '/define',
            method: 'GET',
            data: {}
        };
        return self.sendRequest(params, forceReload);
    },




    getDefineCombo2: function(params, forceReload){
        var self = this;
        return self.getDefinePrepared2(params, forceReload).then(res => {
            return res;
        });
    },
    getDefinePrepared2: function(params, forceReload){
        var self = this;
		return self.define(params, forceReload).then(res => {
            let valores = self._prepareDefinition2(res);
            // Ordenamos los valores por el nombre y lo devolvemos
            return valores.sort((a, b) => a.name.localeCompare(b.name));
        });
    },
    // procesamos cada property (árbol que ramifica por el campo children) para montar una lista de objetos con los campos name, value, tipo y children (este solo si el tipo es list)
	_prepareDefinition2(hijo, padre){
		var self = this;
        var preparedProp = [];
        // si tenemos parent, lo concatenamos nombre y valor del padre al del hijo
        // - padre: {name: "nombre del padre", content: "valor del padre", tipo: "tipo del padre", children: [hijos del padre]}
        // - hijo: {name: "nombre del hijo", property: "valor del hijo", tipoCampo: "tipo del hijo", children: [hijos del hijo]}
        var nuevoDescriptor = {};
        var descriptorLista = false;
        if(padre){
            nuevoDescriptor = {
                content: (padre.content?padre.content+'.':''  )+hijo.property, 
                name:  (padre.name ?padre.name +' - ':'')+hijo.name, 
                tipo:hijo.tipoCampo,
                children: []
            };
        } else {
            nuevoDescriptor = { content: '$root', name: '', children: [] };
        }
        
        if(hijo.children && hijo.children.length){
            if(hijo.tipoCampo == "list") {
                descriptorLista = {...nuevoDescriptor}
                descriptorLista.content = "$actual";
            }
            hijo.children.forEach(nh => {
                nuevoDescriptor.children.push(...self._prepareDefinition2(nh, hijo.tipoCampo == "list"?descriptorLista:nuevoDescriptor));
            });
            if(hijo.tipoCampo !== "list") {
                preparedProp.push(...nuevoDescriptor.children);
            }
        } 
        // metemos en la lista de objetos a devolver, las descripciones de los nodos hoja y los de los nodos lista
        if(hijo.tipoCampo == "list" || !hijo.children || hijo.children.length == 0) {
            preparedProp.push(nuevoDescriptor);
        } 

        return preparedProp;
	},


    getDefineCombo: function(params, forceReload){
        var self = this;
        return self.getDefinePrepared(params, forceReload).then(valores => {
            return self._tratarObjeto(valores).map(valor => {
                return {name:valor.value, content:valor.name, tipo: valor.tipo};
            });
        });
    },
    getDefinePrepared: function(params, forceReload){
        var self = this;
		return self.define(params, forceReload).then(res => {
            return self._prepareDefinition(res);
        });
    },
	_prepareDefinition(property, parent){
		var self = this;
		var preparedProp = {};
		var propertyData = {};
		if(parent){
			propertyData = Object.assign({},property);
			propertyData.property = (parent.property) ? `${parent.property}.${propertyData.property}` : propertyData.property;
			propertyData.name = (parent.name) ? `${parent.name} - ${propertyData.name}` : propertyData.name;
		}
		if(property.children && property.children.length && property.tipoCampo == "list"){
            const proper = propertyData.tipoCampo ? `${propertyData.property}:${propertyData.tipoCampo}` : propertyData.property;
			preparedProp[proper] = propertyData.name;
			property.children.forEach(child => {
				preparedProp[child.property] = self._prepareDefinition(child, propertyData);
			});
		} else if(property.children && property.children.length){
			property.children.forEach(child => {
				preparedProp[child.property] = self._prepareDefinition(child, propertyData);
			});
		} else {
            const proper = propertyData.tipoCampo ? `${propertyData.property}:${propertyData.tipoCampo}` : propertyData.property;
			preparedProp[proper] = propertyData.name;
		}
		return preparedProp;
	},
    _tratarObjeto: function(objeto, pwd){
        var self = this;
        var valores = [];
        for(const i in objeto){
            const prop = objeto[i];
            if(typeof prop == "object"){
                const nuevos = self._tratarObjeto(prop);
                valores = valores.concat(self._tratarObjeto(prop));
            } else {
                let position = pwd ? `${pwd}.${i}` : i;
                let tipo = undefined;
                if (position.indexOf(":") > -1) {
                    [position, tipo] = position.split(":");
                }
                if(tipo == "list") {
                }
                const nuevo = {name:position, value:prop, tipo:tipo};
                valores.push(nuevo);
            }
        }
        return valores;
    },
    download: function(url, name) {
        var self = this;
        // #663 · Por `peticionDirecta` y no por `request` a pelo: así sale con el token vigente,
        // atiende el 401 como el resto y no guarda el fichero en la sesión de otro.
        return self.peticionDirecta({
            url: url,
            method: 'GET',
            crossDomain: true,
            xhrFields: { 'responseType': 'arraybuffer' }
        }).then(function(res) {
            self._guardarFichero(res.data, name);
        });
    },
    _guardarFichero: function(data, name) {
        const blob = new Blob([data]);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.target = '_blank';
            link.click();
            URL.revokeObjectURL(link.href);
        }
    },
    getBase64: function(url) {
        var self = this;
        return self.peticionDirecta({
            url: url,
            method: 'GET',
            crossDomain: true,
            xhrFields: { 'responseType': 'arraybuffer' }
        }).then(function(res) {
            let array = new Uint8Array(res.data);
            let base64 = window.btoa(
                array.reduce((data, byte) => data + String.fromCharCode(byte), '')
              );
            return {base64, array};
        });
    },
    exportExcel: function(params) {
        var self = this;
        params = params || {};
        const name = params.name || self.model + 's.xlsx';
        return self.peticionDirecta({
            url: self.server_movilidad + self.prefix + self.model + '/excel',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': 'arraybuffer' },
            data: params.filter || {}
        }).then(function(res) {
            self._guardarFichero(res.data, name);
        });
    },
    exportDynamicExcel: function(params) {
        var self = this;
        params = params || {};
        const name = params.name || self.model + 's.xlsx';
        var pagination = {
            sortBy: params.order,
            sortDesc: params.orderDir == 'DESC' ? true : false,
            projection: params.projection,
            operation: params.operation
        };
        var data = {
            filter: params.filter || {},
            columns: params.columns || {},
            pagination: pagination
        }
        return self.peticionDirecta({
            url: self.server_movilidad + self.prefix + self.model + '/dynamicexcel',
            method: 'POST',
            contentType: 'application/json',
            crossDomain: true,
            xhrFields: { 'responseType': 'arraybuffer' },
            data: data
        }).then(function(res) {
            self._guardarFichero(res.data, name);
        });
    },
    /**
     * El token de la sesión guardada, o null. Es el mismo que pone `Framework7.request.setup`,
     * pero leído en el momento de la petición.
     */
    tokenDeSesion: function() {
        try {
            const session = JSON.parse(localStorage.getItem('session') || 'null');
            return (session && (session.token || session.access_token)) || null;
        } catch (e) {
            return null;
        }
    },
    /**
     * Las cabeceras de una petición con el Authorization de la sesión vigente añadido.
     *
     * Vive aquí, y no en cada adaptador, porque hace falta en dos sitios: en `sendRequest` (race
     * del F5 y de la pestaña nueva, donde un componente dispara HTTP en `mounted` antes de que
     * `startSession()` llame a `Framework7.request.setup`) y en las llamadas que van por su cuenta
     * a `request.promise`, que si no usarían la cabecera global del setup —y esa se queda con el
     * token viejo cuando la sesión se renueva sin recargar la aplicación: en Cordova, al volver de
     * una notificación, se guarda la sesión nueva y no se vuelve a llamar a setup, así que el
     * servidor contestaba 401 y la pantalla echaba al usuario teniendo sesión válida—.
     *
     * Sin token devuelve las cabeceras tal cual, incluido `undefined`: un `headers: {}` sustituye
     * entero al global de Framework7 y dejaría la petición sin Authorization ninguno.
     */
    conCabeceraDeSesion: function(headers) {
        const token = this.tokenDeSesion();
        if (!token) return headers;
        return Object.assign({}, headers || {}, { Authorization: 'Bearer ' + token });
    },
    /**
     * `true` si lo que ha fallado es que el servidor ha rechazado el token (caducado, revocado o
     * inválido). Es la ÚNICA definición de «la sesión ya no vale» de este modelo: la usan
     * `sendRequest` y `peticionDirecta`, para que las dos entiendan lo mismo por un 401.
     */
    esSesionRechazada: function(e) {
        if (!e || typeof e !== 'object') return false;
        if (e.status == 401) return true;
        try {
            const cuerpo = e.xhr && e.xhr.response ? JSON.parse(e.xhr.response) : null;
            return !!cuerpo && cuerpo.error === 'invalid_token';
        } catch (noEraJson) {
            // Un cuerpo que no es JSON no dice nada del token: manda el estado HTTP.
            return false;
        }
    },
    /**
     * Atiende un 401 y dice en qué quedó: `CERRADA`, `OTRA_SESION`, `SIN_APLICACION` —o `null`
     * cuando no era una sesión rechazada y hay que tratarlo como cualquier otro error—.
     *
     * **Quién decide no es este modelo**: es `cierreDeSesionPor401`, el único sitio del repo donde
     * está escrito que un 401 cierra la sesión **que lo provocó** y no la que haya puesta al
     * contestar. Lo necesitan tres manejadores que no pasan uno por otro —este, el multipart del
     * boletín de festivos y el 401 de `Usuario.me()`—, y repartido estaba en uno de los tres: la
     * consulta de la cuenta A echaba a la cuenta B, que acababa de entrar (revisión CODEX del PR
     * #1735). Aquí solo se traduce el error a la pregunta que ese módulo contesta.
     */
    atender401: function(e, tokenAlEnviar) {
        if (!this.esSesionRechazada(e)) return null;
        const desenlace = cerrarSesionPor401(tokenAlEnviar);
        if (desenlace === CERRADA) {
            // El indicador de espera se apaga aquí y solo al cerrar de verdad: es un modal de la
            // APLICACIÓN, así que apagarlo por un 401 ajeno dejaría sin indicador a la carga de la
            // cuenta que acaba de entrar (ver `preloaderDeLaSesion`).
            const app = typeof window != 'undefined' ? window.app : null;
            if (app && app.preloader) app.preloader.hide();
        }
        return desenlace;
    },
    /**
     * El tratamiento de una sesión rechazada: cerrar sesión y llevar al login (el navigate lo hace
     * `removeSession()` por su cuenta).
     *
     * Devuelve `true` si lo ha hecho y `false` si no había que hacerlo, para que quien llama
     * rechace como rechazaría cualquier otro error. Se queda en `false` cuando el 401 es de un
     * token que YA NO es el de la sesión guardada —se renovó mientras la petición estaba en curso,
     * lo que en Cordova pasa al volver de una notificación, y también cuando alguien cierra sesión
     * y entra con otra cuenta en la misma pestaña—: ahí la sesión sigue valiendo y cerrarla sería
     * echar al usuario teniendo sesión válida, el mismo defecto que arregló `conCabeceraDeSesion`.
     *
     * El indicador de espera lo apaga `atender401`, y **solo cuando se ha cerrado de verdad**.
     */
    cerrarSesionRechazada: function(e, tokenAlEnviar) {
        return this.atender401(e, tokenAlEnviar) === CERRADA;
    },
    /**
     * Una petición que no puede pasar por `sendRequest` —porque su respuesta no tiene la forma de
     * `ResponseDto`, o porque no quiere caché— pero que cumple su MISMO contrato de sesión: viaja
     * con el Authorization vigente y, si el servidor rechaza el token, cierra la sesión por el
     * mismo camino en vez de devolver un error genérico.
     *
     * Existe porque la revisión del PR #1783 sacó dos veces la misma causa de fondo en la misma
     * llamada —la cabecera de sesión (ronda 8) y el 401 (ronda 10)—: cada garantía que
     * `sendRequest` da en un sitio había que repetirla a mano en cada `request.promise`, y así la
     * siguiente garantía que falte vuelve a salir una ronda después. Aquí pasan todas las llamadas
     * directas, y lo que se añada vale para todas.
     *
     * Devuelve la promesa cruda de Framework7 (`{data, xhr, status}`), así que cada método conserva
     * su propio `then`/`catch`: esto NO cambia qué resuelve ni cómo rechaza ninguno.
     */
    peticionDirecta: function(params) {
        const self = this;
        // #663 · Con qué sesión sale: lo que conteste otra sesión no llega a la pantalla.
        const generacion = generacionActual();
        const tokenAlEnviar = self.tokenDeSesion();
        const peticion = Object.assign({}, params || {}, {
            headers: self.conCabeceraDeSesion(params ? params.headers : undefined)
        });
        return atarALaSesion(self.request.promise(peticion).catch(function(e) {
            if (self.cerrarSesionRechazada(e, tokenAlEnviar)) {
                // Igual que `sendRequest`: no se rechaza. La aplicación ya va camino del login y un
                // aviso de error encima solo taparía la pantalla de entrada. La espera no se queda
                // colgada: cerrar la sesión la termina con la cancelación de `sesionDePeticiones`.
                return new Promise(function() {});
            }
            return Promise.reject(e);
        }), generacion);
    },
    sendRequest: function(params, cached, callback, errorCallback, completeCallback){
        var self = this;
        var callback = callback;
        var errorCallback = errorCallback;
        var params = Object.assign({
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            expiresIn: self.cache_expiration_time
        }, params);

        // Inyecta Authorization desde localStorage si aún no se llamó a Framework7.request.setup
        // (race en F5/nueva pestaña: componentes pueden disparar HTTP en mounted antes
        // de que startSession() corra dentro de $f7ready).
        params.headers = self.conCabeceraDeSesion(params.headers);
        // Con qué token sale: es de qué SESIÓN es esta petición, y lo necesita el 401 de abajo
        // para no cerrar una sesión distinta de la que la pidió (ver `desenlaceDe401`).
        const tokenAlEnviar = self.tokenDeSesion();
        // Y en qué sesión de avisos: si se cierra antes de que conteste, su error ya no es de nadie
        // que pueda ver el aviso y no debe emparejar los de quien entre (#765).
        const sesionDeAvisos = AvisoUnicoDeError.sesion();
        // #663 · Y en qué generación de sesión: es la frontera común. Lo que conteste —éxito, error
        // o caché— después de cerrar o cambiar de sesión termina en cancelación sin ejecutar nada
        // de la pantalla, y renovar el token de la misma sesión no la cambia (`sesionDePeticiones`).
        const generacion = generacionActual();

        var method = (params.method || 'GET').toUpperCase();
        var contentType = params.contentType || '';
        if (
            method !== 'GET' &&
            method !== 'HEAD' &&
            contentType.indexOf('application/json') > -1 &&
            typeof params.data === 'object' &&
            params.data !== null &&
            !(params.data instanceof FormData)
        ) {
            params.processData = false;
            params.data = JSON.stringify(params.data);
        }

        var cached = cached != undefined ? cached : true;
        var completeCallback = completeCallback || function() {};
        if (cached) {
            var cachedRequest = CacheService.getCachedRequest(self.model, params);
            if (cachedRequest) {
                // La caché devuelve la misma promesa a varios llamantes: cada uno se ata a SU sesión.
                return atarALaSesion(cachedRequest, generacion);
            }
        }
        var promise = new Promise(function(resolve, reject) {
            var callback = callback || function(res) {
                if (res.data.error) {
                    reject(res.data);
                } else if (typeof(res.data.dto) == 'boolean' || res.data.dto) {
                    resolve(res.data.dto);
                } else {
                    resolve(res.data);
                }
            };
            var errorCallback = errorCallback || function(e) {
                if (typeof e == 'string') e = { error: e };
                if (typeof e == 'undefined') e = { error: 'Error desconocido' };
                if(e.status == 404) {
                    if(e.xhr && e.xhr.requestUrl) {console.log('URL: '+e.xhr.requestUrl);}
                    reject({status: e.status, xhr: e.xhr, message: e.message});
                    return;
                }
                // Timeout de pasarela: 524/522/520 (Cloudflare), 504, 408, o status 0 (la
                // conexión se cortó sin respuesta). El servidor puede seguir procesando y
                // llegar a aplicar el cambio, así que avisamos de que recarguen antes de
                // reintentar, para no duplicar la operación.
                if ([408, 504, 520, 522, 524, 598, 599].indexOf(e.status) !== -1 || e.status === 0) {
                    reject({
                        status: e.status,
                        xhr: e.xhr,
                        // La MARCA de «no se sabe si se escribió», para que una pantalla pueda
                        // distinguir este fallo de un rechazo del servidor sin volver a enumerar
                        // los estados: la lista vive aquí y en un solo sitio. Un rechazo de verdad
                        // (400, 403, 409…) deja reintentar; esto no puede, porque el servidor
                        // puede haber escrito ya y una segunda pulsación duplicaría la operación.
                        respuestaPerdida: true,
                        message: "La petición ha tardado demasiado tiempo y se ha cerrado. Es posible que el cambio sí se haya aplicado: recarga la pantalla para comprobarlo antes de volver a intentarlo."
                    });
                    return;
                }
                if (e.xhr) {
                    var { xhr, status, message } = e;
                    // Token rechazado por el servidor (expirado, revocado o inválido) → cerrar
                    // sesión y redirigir. El tratamiento vive en `cerrarSesionRechazada`, que es el
                    // mismo que usan las llamadas directas de `peticionDirecta`; se decide ANTES de
                    // leer el cuerpo porque un 401 con cuerpo que no es JSON (la página de error de
                    // una pasarela) es igual de 401 y antes acababa en un mensaje de parseo.
                    const desenlace = self.atender401(e, tokenAlEnviar);
                    if (desenlace === CERRADA) {
                        return;
                    }
                    if (desenlace) {
                        // El 401 no era de esta sesión —o no había aplicación con la que cerrar—,
                        // así que no se echa a nadie. Pero se CONTESTA, en vez de dejar la promesa
                        // sin cerrar: quien esperaba tiene que dejar de esperar. Si la respuesta
                        // era de otra sesión, el carril y `accionDeLaSesion` la descartan sin
                        // pintar nada ni avisar de ningún error.
                        reject({
                            status: status,
                            xhr: xhr,
                            sesionAjena: desenlace === OTRA_SESION,
                            message: desenlace === OTRA_SESION
                                ? "La sesión ha cambiado mientras se esperaba al servidor, así que esta petición se ha quedado sin permiso. Vuelve a intentarlo."
                                : "La sesión ha caducado."
                        });
                        return;
                    }
                    try {
                        let errorCode = xhr.response ? JSON.parse(xhr.response).error : "Error al efectuar una petición al servidor";
                        // #765 · La API pone esta cabecera cuando el mismo error sale además como
                        // aviso por SSE: apuntarla es lo que deja enseñar uno solo de los dos.
                        const referencia = typeof xhr.getResponseHeader === 'function'
                            ? xhr.getResponseHeader('X-Referencia-Error') : null;
                        errorCode = {
                            status: e.status,
                            xhr: e.xhr,
                            message: errorCode.message || errorCode,
                            code: errorCode.code || null,
                            errors: errorCode.errors || null,
                            referencia: referencia || null
                        }
                        AvisoUnicoDeError.desdeRespuesta(referencia, errorCode.message, sesionDeAvisos);
                        reject(errorCode);
                    } catch (noEraJson) {
                        // El cuerpo no era JSON: se rechaza con el estado y el mensaje de LA
                        // RESPUESTA, no con los del error de parseo —que no tiene `status` ni `xhr`
                        // y enseñaba «Unexpected token <» a quien estaba usando la pantalla—.
                        reject({
                            status: status,
                            xhr: xhr,
                            message: message || "Error al efectuar una petición al servidor"
                        });
                    }
                } else {
                    reject(e);
                }
            }
            self.request.promise(params).then(callback).catch(errorCallback).then(function() {
                // Es código del llamante, como el `then` que cuelgue de la promesa.
                if (sigueLaGeneracion(generacion)) completeCallback();
            });
        });
        // A la caché va la promesa cruda: la comparten las llamadas de la misma generación, y la
        // caché no deja que la sirva otra (`Cache.js`).
        CacheService.addCachedRequest(self.model, params, promise);
        return atarALaSesion(promise, generacion);
    },
    resetCache: function(){
        var self = this;
        CacheService.clearCache(self.model);
    }
}

export default DatabaseModel;